import { schemaData } from '$shared/lib/data/SchemaData';
import { CommonList } from '$shared/models/CommonList';

export class MonitorIntervalHelper {
  static forDaily(): string[] {
    const interval = schemaData.MonitoringInterval;
    return [interval.Daily, interval.Weekly, interval.Monthly, interval.Yearly];
  }

  static forWeekly(): string[] {
    const interval = schemaData.MonitoringInterval;
    return [interval.Weekly, interval.Monthly, interval.Yearly];
  }

  static forMonthly(): string[] {
    const interval = schemaData.MonitoringInterval;
    return [interval.Monthly, interval.Yearly];
  }

  static forYearly(): string[] {
    const interval = schemaData.MonitoringInterval;
    return [interval.Yearly];
  }

  static forContinuous(): string[] {
    const interval = schemaData.MonitoringInterval;
    return [interval.Continuous];
  }

  static getList(defaultInterval: string): CommonList[] {
    let intervals: string[] = [];
    const monitoringInterval = schemaData.MonitoringInterval;
    switch (defaultInterval) {
      case monitoringInterval.Monthly:
        intervals = MonitorIntervalHelper.forMonthly();
        break;
      case monitoringInterval.Weekly:
        intervals = MonitorIntervalHelper.forWeekly();
        break;
      case monitoringInterval.Yearly:
        intervals = MonitorIntervalHelper.forYearly();
        break;
      case monitoringInterval.Continuous:
        intervals = MonitorIntervalHelper.forContinuous();
        break;
      default:
        intervals = MonitorIntervalHelper.forDaily();
        break;
    }

    return intervals.map((interval: string) => CommonList.create(interval, interval));
  }
}
